import { AnalyticsController } from 'analytics/analytics-controller';
import { GTM_CLICK_NAV_LOCALE_CHANGE_EN_CA, GTM_CLICK_NAV_LOCALE_CHANGE_FR_CA } from 'constants/events';
import { SiteLanguage } from 'types/locales';

/**
 * Mapping of locale IDs to their tracking functions.
 * Each function is called when that locale option is selected in the locale switcher.
 */
export const LOCALE_TRACKING_MAP: Partial<Record<SiteLanguage, () => void>> = {
  [SiteLanguage.EnglishCA]: () => {
    AnalyticsController.trackEvent(GTM_CLICK_NAV_LOCALE_CHANGE_EN_CA);
  },
  [SiteLanguage.FrenchCA]: () => {
    AnalyticsController.trackEvent(GTM_CLICK_NAV_LOCALE_CHANGE_FR_CA);
  },
};

